export default "__VITE_ASSET__YGvxM9PL__"